export default "__VITE_ASSET__CB9ZEkJX__"